module.exports = eval("try{require('net')}catch(e){}");